import { MutationTree } from 'vuex'
import { EventsState } from './types'

export const mutations: MutationTree<EventsState> = {
    toggleBatchLock(state, toggle) {
        state.isBatchLocked = toggle;
    }
}
